<template>
  <div>
    <div class="virtualPrivateCloudResourceAzure-title">
      <div>{{ $t("RAM.Azure.VirtualNetwork.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="virtualPrivateCloudResourceAzure-top">
      <virtual-private-cloud-resource-azure-search
        ref="search"
      ></virtual-private-cloud-resource-azure-search>
    </div>
    <table-virtual-private-cloud-resource-azure></table-virtual-private-cloud-resource-azure>
  </div>
</template>

<script>
import VirtualPrivateCloudResourceAzureSearch from "../vpc/VirtualPrivateCloudResourceAzureSearch";
import TableVirtualPrivateCloudResourceAzure from "../vpc/TableVirtualPrivateCloudResourceAzure";

export default {
  name: "VirtualPrivateCloudResourceAzure",
  components: {
    VirtualPrivateCloudResourceAzureSearch,
    TableVirtualPrivateCloudResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 203
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureVirtualNetwork({
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.virtualNetwork');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.virtualPrivateCloudResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.virtualPrivateCloudResourceAzure-title > div:nth-child(1) {
  float: left;
}
.virtualPrivateCloudResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.virtualPrivateCloudResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/vpc/VirtualPrivateCloudResourceAzure.vue